module.exports = __webpack_public_path__ + "static/carter005-470c6089a1e2a8053ea4f2ab84e2b4cb.jpg";